module.exports = __webpack_public_path__ + "static/media/eventsIcon.f00e533a.jpg";